export const toFixedWithoutZeros = (num: number | string, precision = 2) =>
  Number(num).toFixed(precision).replace(/\.0+$/, '');

export const isNumeric = (val: number | string) => !isNaN(+val) && !isNaN(parseFloat(String(val)));
